import { useQuery } from "@tanstack/react-query";
import activityLogService from "../api/activityLogService";
import moment from "moment";

export const useActivityLogs = (taskId) => {
  const { getAllActivityLogs } = activityLogService();

  return useQuery({
    queryKey: ["get-activity-logs", taskId],
    queryFn: async () => {
      const res = await getAllActivityLogs(taskId);
      let a = [...res.data];
      a.sort((a, b) => moment(b.CreatedDate).diff(a.CreatedDate));
      return a;
    },
    enabled: !!taskId,
  });
};

export const useFirstAndLastActivityLogs = (taskId) => {
  const { getFirstAndLastActivityLogs } = activityLogService();

  return useQuery({
    queryKey: ["get-activity-logs-first-last", taskId],
    queryFn: async () => {
      const res = await getFirstAndLastActivityLogs(taskId);
      let a = [...res.data];
      a.sort((a, b) => moment(b.CreatedDate).diff(a.CreatedDate));
      return a;
    },
    enabled: !!taskId,
  });
};
